<template>
  <nav class="bg-gradient-to-r from-white via-primary-50 to-secondary-50 shadow-sm">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">
        <div class="flex flex-1 items-center">
          <div class="flex flex-shrink-0 items-center">
            <Link href="/" class="transition-all hover:opacity-80">
              <img :src="logo" class="h-10 w-auto rounded bg-white p-1 shadow-sm" :alt="settings.name" />
            </Link>
          </div>
          <div class="ml-4 hidden md:block">
            <span class="text-sm font-medium text-gray-500">{{ slogan }}</span>
          </div>
          <div class="flex-grow"></div>
          <div class="mr-6 flex items-center gap-4">
            <Link
              href="/"
              class="rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-200"
              :class="{ 'ring-2 ring-primary-500': isActive('/') }"
            >
              Jobs
            </Link>
          </div>
        </div>
        <div class="hidden items-center md:flex">
          <Link
            href="/arbeitgeber"
            class="rounded-full bg-gradient-to-r from-primary-600 to-secondary-500 px-5 py-2 text-sm font-semibold text-white shadow-md transition-all hover:shadow-lg hover:brightness-110"
          >
            {{ $t("components.navbar.anzeige_schalten") }}
          </Link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import { Link, usePage } from "@inertiajs/inertia-vue3"
import { computed } from "vue"
import logo from "@/images/arztundpflegejobs/logo-wide.png"

const page = usePage()
const settings = computed(() => page.props.value.settings || {})
const slogan = computed(() => settings.value.slogan_de)

const isActive = (path: string) => {
  return window && path === window.location.pathname
}
</script>
